<div class="mt-4" *ngIf="loading">
  <div class="loading-div">
    <img
      class="evo-loading-img"
      *ngIf="!organizationService.currentOrganization.whiteLabel"
      src="assets/images/logo-evollo.png"
      alt="loading_img" />
    <img
      class="evo-loading-img"
      *ngIf="organizationService.currentOrganization.whiteLabel"
      [src]="organizationService.currentOrganization.logoUrl"
      alt="loading_img" />
  </div>